import angular from 'angular'
import templateUrl from './schedule-event-list.component.html'
import { EditScheduleEventModal } from './edit-schedule-event.component.js';
import { ScheduleEventOfficeAssignmentEditorModal } from './schedule-event-office-assignment-editor.component.js';

export const ScheduleEventListComponent = {
    controller: ScheduleEventListController,
    bindings: {
        division: "<",
        startDate: "<?",
        endDate: "<?",
    },
    controllerAs: "vm",
    templateUrl
}

function ScheduleEventListController($uibModal, $q, utilityService, scheduleEventService,
    divisionService, eventHostService) {
    'ngInject'
    const vm = this;
    vm.$onInit = activate;
    vm.$onChanges = onchanges;
    vm.loaded = false;
    vm.scheduleEvents = [];
    vm.filters = {};
    vm.onChangePage = onChangePage;
    vm.onChangeFilters = onChangeFilters;
    vm.addNewScheduleEvent = addNewScheduleEvent;
    vm.editScheduleEvent = editScheduleEvent;
    vm.deleteScheduleEvent = deleteScheduleEvent;
    vm.eventHosts = [];
    vm.pageNumber = 1;
    vm.pageSize = 50;
    vm.onAssignScheduleEvent = onAssignScheduleEvent;
    vm.scheduleEventStatuses = [
        { Name: "Pending", StatusID: 1 },
        { Name: "Accepted", StatusID: 2 },
        { Name: "Rejected", StatusID: 3 },
        { Name: "Unassigned", StatusID: 4 }
    ];

    function activate() {
        initailizePage();
    }

    function onchanges(change) {
        if (change.division) {
            initailizePage();
        }
    }

    function initailizePage() {
        if (vm.division) {
            utilityService.showLoading();
            const loadInitialData = eventHostService.retrieveEventHosts({ DivisionID: vm.division.Id })
                .then(function (eventHosts) {
                    vm.eventHosts = eventHosts
                    vm.eventHosts.forEach(hydrateEventHostName);
                    return vm.eventHosts;
                })
                .then(function (eventHosts) {
                    vm.filters = {
                        PageNumber: vm.pageNumber,
                        PageSize: vm.pageSize
                    };
                    vm.filters.StartDate = vm.startDate;
                    vm.filters.EndDate = vm.endDate;
                    return loadScheduleEvents();
                });

            loadInitialData
                .then(function () {
                    vm.loaded = true;
                })
                .catch(function (ex) {
                    console.error(ex);
                    alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
                })
                .then(function () {
                    utilityService.hideLoading();
                });
        }
    }

    function hydrateEventHostName(eventHost) {
        const name = eventHost.HostLocationName
            ? `${eventHost.HostName} (${eventHost.HostLocationName})`
            : eventHost.HostName
        eventHost.Text = name;
    }

    function loadScheduleEvents() {
        const param = generateQueryParameter();
        return scheduleEventService.retrieveScheduleEventsPage(param.PageIndex, param)
            .then(function (scheduleEvents) {
                vm.scheduleEvents = scheduleEvents;
                scheduleEvents.Entities = scheduleEvents.Entities.map(mapScheduleEvents)
                return vm.scheduleEvents
            })
    }

    function mapScheduleEvents(event) {
        event.AssignedStatus = event.ScheduleEventOffices.map(function (office) {
            return office.AssignedStatus;
        }).filter(function (value, index, self) {
            return self.indexOf(value) === index;
        }).join(",");

        return event;
    }

    function onChangeFilters() {
        if (vm.loaded) {
            vm.filters.PageNumber = vm.pageNumber;
            vm.filters.PageSize = vm.pageSize;
            utilityService.showLoadingUntilResolved(
                utilityService.alertOnError(loadScheduleEvents(), "Changing page failed"));
        }

    }

    function onChangePage() {
        if (vm.loaded) {
            utilityService.showLoadingUntilResolved(
                utilityService.alertOnError(loadScheduleEvents(), "Changing page failed"));
        }
    }

    function generateQueryParameter() {
        const params = {
            PageIndex: vm.filters.PageNumber - 1,
            PageSize: vm.filters.PageSize,
            AssignedStatus: vm.filters.AssignedStatusID,
            HostLocationName: vm.filters.HostLocationName,
            HostName: vm.filters.HostName,
            OwnerClientName: vm.filters.OwnerClientName,
            HostNumber: vm.filters.HostNumber,
            StartDate: vm.filters.StartDate,
            EndDate: vm.filters.EndDate,
            DivisionID: vm.division.Id
        }
        return params;
    }


    function addNewScheduleEvent() {
        showEditForm();
    }

    function editScheduleEvent(scheduleEvent) {
        showEditForm(scheduleEvent);
    }

    function showEditForm(scheduleEvent) {
        return $uibModal.open({
            ...EditScheduleEventModal,
            resolve: {
                scheduleEvent: () => scheduleEvent ? angular.copy(scheduleEvent) : {},
                eventHosts: () => vm.eventHosts,
                divisionID: () => vm.division.Id,
            }
        })
            .result
            .then(function (scheduleEvent) {
                initailizePage();
            });
    }

    function onAssignScheduleEvent(scheduleEvent) {
        return $uibModal.open({
            ...ScheduleEventOfficeAssignmentEditorModal,
            resolve: {
                scheduleEvent: () => scheduleEvent ? angular.copy(scheduleEvent) : {},
                divisionID: () => vm.division.Id,
            }
        })
            .result
            .then(function (scheduleEvent) {
                initailizePage();
            });

    }

    function deleteScheduleEvent(scheduleEvent) {

        utilityService.showLoading();
        scheduleEventService.deleteScheduleEvent(scheduleEvent.ScheduleEventID)
            .catch(function (ex) {
                alert("Deleting event host failed: " + (ex.statusText || ex))
            })
            .then(function () {
                utilityService.hideLoading();
                utilityService.showLoadingUntilResolved(
                    utilityService.alertOnError(loadScheduleEvents(), "Loading page failed"));
            });
    }

}
